import React, { useEffect, useRef, useState} from 'react';
import styles from './Merging.module.css';
import Row from 'react-bootstrap/Row';
import {DndProvider} from 'react-dnd';
import {HTML5Backend} from 'react-dnd-html5-backend';
import axios from "axios";
import apiUrl from "../../shared/config";
import RelatedPatternMergingDisplay from "./RelatedPatternMergingDisplay/RelatedPatternMergingDisplay";
import ExampleGamesMergingDisplay from "./ExampleGamesMergingDisplay/ExampleGamesMergingDisplay";
import KeywordsMergingDisplay from "./KeywordsMergingDisplay/KeywordsMergingDisplay";
import ExercisesMergingDisplay from "./ExercisesMergingDisplay/ExercisesMergingDisplay";
import ConditionsMergingDisplay from "./ConditionsMergingDisplay/ConditionsMergingDisplay";
import ConstraintsMergingDisplay from "./ConstraintsMergingDisplay/ConstraintsMergingDisplay";
import ConsequencesMergingDisplay from "./ConsequencesMergingDisplay/ConsequencesMergingDisplay";
import CustomDragLayer from "./DraggingWrappers/CustomDragLayer";
import {useDispatch, useSelector} from "react-redux";
import * as actionTypes from '../../store/actions/actionTypes'
import SimpleMergeTextFields from "./SimpleMergeTextFields/SimpleMergeTextFields";
import DesignProblemMergingDisplay from "./DesignProblemMergingDisplay/DesignProblemMergingDisplay";
import AuthorsMergingDisplay from "./AuthorsDisplay/AuthorsMergingDisplay";
import GroupsMergingDisplay from "./GroupsMergingDisplay/GroupsMergingDisplay";
import Pattern from "../Pattern/Pattern";
import {Forward} from "@material-ui/icons";
import PatternStateDropdown from "../NewPattern/PatternStateDropdown/PatternStateDropdown";
import Spinner from "react-bootstrap/Spinner";
import Button from 'react-bootstrap/Button';
import SubmitButtonWarning from "../UI/SubmitButtonWarning/SubmitButtonWarning";


export default function MergeScreen({patternSelected, gameSelected, userId}) {
    const [fromPattern, setFromPattern] = useState()
    const [toPattern, setToPattern] = useState()
    const [isLoading, setIsLoading] = useState(false)
    const [patternStateId, setPatternStateId] = useState(toPattern && toPattern.pattern_state_id ? toPattern.pattern_state_id : 1)
    const show = useSelector(state => state.modal.merge_modal.isOpen)
    const to = useSelector(state => state.modal.merge_modal.selectedTo)
    const from = useSelector(state => state.modal.merge_modal.selectedFrom)
    const token = useSelector(state => state.auth.token)
    const dispatch = useDispatch();

    const [failMessage, setFailMessage] = useState("")
    const [showFailMessage, setShowFailMessage] = useState(false)

    // refs for separate pattern components
    const groupsRef = useRef()
    const descriptiveTitleRef = useRef()
    const problemsRef = useRef()
    const descriptionRef = useRef()
    const keywordsRef = useRef()
    const conditionsRef = useRef()
    const constraintsRef = useRef()
    const consequencesRef = useRef()
    const exampleGamesRef = useRef()
    const relatedPatternsRef = useRef()
    const exercisesRef = useRef()
    const authorsRef = useRef()
    const titleRef = useRef()

    const modalRef = useRef();

    // get pattern info
    useEffect(() => {
        axios.get(apiUrl + 'Pattern/getbyid?pattern_id=' + to.id + '&token=' + token).then(
            response => {
                setToPattern(response.data)
                setPatternStateId(response.data.pattern_state_id)
            }
        )
        axios.get(apiUrl + 'Pattern/getbyid?pattern_id=' + from.id + '&token=' + token).then(
            response => {
                setFromPattern(response.data)
            }
        )
    }, [from.id, to.id, token]);

    useEffect(() => {
        if (modalRef.current && show) {
            modalRef.current.open();
        }
    }, [show]);

    // useEffect(() => {
    //     const getProblems = () => {
    //         if (problemsRef && problemsRef.current) {
    //             return problemsRef.current.getList().map((problem, index) => ({value: problem.design_problem_id, label: `Design Problem ${index + 1}`}))
    //         } else {
    //             return []
    //         }
    //     }
    //
    //     console.log('refreshed', setProblems)
    //
    //     setProblems(getProblems())
    // }, [setProblems, problemsRef.current.getList()])



    //TODO: catches should throw an error. Also maybe add a can update (similar to in NewPattern) to check for invalid fields before sending request.
    const sendMerge = (data) => {
        if (!isLoading) {
            setIsLoading(true)

            axios.post(apiUrl + 'Pattern/set?token=' + token, data).then(r => {
                if (!r.data.message) {
                    setIsLoading(false)
                    // I don't really know why but these seem to have to be separate calls to work properly. Might be a race condition idk
                    dispatch({type: actionTypes.CLOSE_MERGE_MODAL, selectedPattern: null})
                    dispatch({type: actionTypes.SELECT_PATTERN, selectedPatternId: r.data.pattern_id || null})
                } else {
                    setFailMessage(r.data.message)
                    setShowFailMessage(true)
                    setIsLoading(false)
                }
            }).catch(e => {
                console.log(e)
                setIsLoading(false)
            })
        }
    }

    const addHandler = () => {
            const formattedDesignProblems = problemsRef && problemsRef.current && Array.isArray(problemsRef.current.getList())
                ? problemsRef.current.getList().map((problem, index) => {
                    let newProb = {...problem, order_id: index + 1, isOrderIdMapped: true, user_id: userId}
                    // delete newProb.design_problem_id;
                    return newProb;
                })
                : [] // shouldn't happen but just to be safe we set to a [];

            const formattedGames = exampleGamesRef?.current && Array.isArray(exampleGamesRef.current.getList())
                ? exampleGamesRef.current.getList().map((game) => {
                    // Map each `game.design_problems` to the corresponding index in `toPattern.design_problems`
                    let mappedDesignProblems = game.design_problems.map((designProblemId) => {
                        // Find the index of the design problem in `toPattern.design_problems`
                        const problemIndex = problemsRef?.current.getList().findIndex(
                            (p) => +p.design_problem_id === +designProblemId
                        );
                        return problemIndex !== -1 ? problemIndex + 1 : -1;
                    });

                    // filter out bad values
                    mappedDesignProblems = mappedDesignProblems.filter(p => p >= 0)

                    // Return the modified game with updated `design_problems` array
                    return {...game, design_problems: mappedDesignProblems};
                })
                : [] // shouldn't happen but just to be safe we set to a []


            const data = {
                ...toPattern,
                pattern_name: titleRef && titleRef.current ? titleRef.current.getText() || (toPattern && toPattern.pattern_name) : "",
                pattern_descriptive_title: descriptiveTitleRef && descriptiveTitleRef.current ? descriptiveTitleRef.current.getText() || (toPattern && toPattern.pattern_descriptive_title) : "",
                design_problems: formattedDesignProblems || [],
                pattern_description: toPattern && toPattern.pattern_description ? {...toPattern.pattern_description, description: descriptionRef?.current?.getText()} : {description: ""}, // Use a fallback if `descriptionRef` is null
                keywords: keywordsRef?.current?.getList() || [],
                conditions: conditionsRef?.current?.getList() || [],
                constraints: constraintsRef?.current?.getList() || [],
                consequences: consequencesRef?.current?.getList() || [],
                authors: authorsRef?.current?.getList() || [],
                groups: groupsRef?.current?.getList() || [],
                related_patterns: relatedPatternsRef?.current?.getList() || [],
                example_games: formattedGames || [],
                suggested_exercises: exercisesRef?.current?.getList() || [],
                pattern_state_id: +patternStateId,
                merged: {
                    from_id: +fromPattern.pattern_id,
                }
            };
            sendMerge(data);
    }



    return (
        <DndProvider backend={HTML5Backend}>
            <div className={styles.Screen + " card pattern-details"}>
                <h1 className={'card-header'}>
                    <Row>
                        <div className="col-sm-2">
                            <PatternStateDropdown
                                patternStateId={patternStateId}
                                onStateChange={(id) => setPatternStateId(id)}
                                hideMerged
                            />
                        </div>
                        <div className='col-sm-8'>Merging</div>
                        <div className='col-sm-2'/>
                    </Row>
                </h1>
                <div className={styles.Container} style={{paddingTop: '15px'}}>
                    {/*<div className={styles.SplitCols}>*/}
                    <div style={{width: '45%', justifySelf: "left",}}>
                        <Pattern
                            name={toPattern && toPattern.pattern_name ? toPattern.pattern_name : "loading..."}
                            cardBodyText={'Items added during merge can be dragged to the right to remove them from your pattern.'}
                            noBodyTrunc
                            titleCSS={styles.ToColor}
                        />
                    </div>
                    {/*<h1>{toPattern && toPattern.pattern_name ? toPattern.pattern_name : "loading..."}</h1>*/}
                    {/*</div>*/}
                    {/*<div className={styles.Separator}>*/}
                    <Forward style={{fontSize: 100, transform: 'rotate(180deg)', alignSelf: 'center'}}/>
                    {/*</div>*/}
                    {/*<div className={styles.SplitCols}>*/}
                    <div style={{width: '45%', justifySelf: "right"}}>
                        <Pattern
                            name={fromPattern && fromPattern.pattern_name ? fromPattern.pattern_name : "loading..."}
                            cardBodyText={'Drag items to the left to merge them into your pattern.'}
                            noBodyTrunc
                            titleCSS={styles.FromColor}
                        />
                    </div>
                    {/*<h1>{fromPattern && fromPattern.pattern_name ? fromPattern.pattern_name : "loading..."}</h1>*/}
                    {/*</div>*/}
                </div>
                <hr className={styles.HorizontalSeparator}></hr>
                <AuthorsMergingDisplay ref={authorsRef} fromPattern={fromPattern} toPattern={toPattern}/>
                <GroupsMergingDisplay ref={groupsRef} fromPattern={fromPattern} toPattern={toPattern}
                                      patternSelected={patternSelected}/>
                <SimpleMergeTextFields ref={titleRef} title={'Pattern Title:'} rows={2}
                                       toPattern={toPattern && toPattern.pattern_name ? toPattern.pattern_name : ""}
                                       fromPattern={fromPattern && fromPattern.pattern_name ? fromPattern.pattern_name : ""}/>
                <SimpleMergeTextFields ref={descriptiveTitleRef} title={'Descriptive Title:'} rows={2}
                                       toPattern={toPattern && toPattern.pattern_descriptive_title ? toPattern.pattern_descriptive_title : ""}
                                       fromPattern={fromPattern && fromPattern.pattern_descriptive_title ? fromPattern.pattern_descriptive_title : ""}/>
                <SimpleMergeTextFields ref={descriptionRef} title={'Pattern Description:'}
                                       toPattern={toPattern && toPattern.pattern_description && toPattern.pattern_description.description ? toPattern.pattern_description.description : ''}
                                       fromPattern={fromPattern && fromPattern.pattern_description && fromPattern.pattern_description.description ? fromPattern.pattern_description.description : ""}/>

                <DesignProblemMergingDisplay ref={problemsRef} toPattern={toPattern} fromPattern={fromPattern}
                                             patternSelected={patternSelected}/>
                <KeywordsMergingDisplay ref={keywordsRef} patternSelected={patternSelected} fromPattern={fromPattern}
                                        toPattern={toPattern}/>
                <ConditionsMergingDisplay ref={conditionsRef} patternSelected={patternSelected}
                                           fromPattern={fromPattern}
                                           toPattern={toPattern}/>
                <ConstraintsMergingDisplay ref={constraintsRef} patternSelected={patternSelected}
                                           fromPattern={fromPattern}
                                           toPattern={toPattern}/>
                <ConsequencesMergingDisplay ref={consequencesRef} patternSelected={patternSelected}
                                           fromPattern={fromPattern}
                                           toPattern={toPattern}/>
                <ExampleGamesMergingDisplay ref={exampleGamesRef} toPattern={toPattern}
                                            patternSelected={patternSelected} fromPattern={fromPattern}
                />
                <RelatedPatternMergingDisplay ref={relatedPatternsRef} patternSelected={patternSelected}
                                              fromPattern={fromPattern}
                                              toPattern={toPattern}/>
                <ExercisesMergingDisplay ref={exercisesRef} patternSelected={patternSelected} fromPattern={fromPattern}
                                         toPattern={toPattern}/>

                <div className={styles.ButtonsContainer}>
                    {isLoading && (
                        <Spinner
                            animation="border"
                            style={{width: 30, height: 30, marginLeft: 16}}
                        />
                    )}
                    <SubmitButtonWarning
                        token={token} userId={userId}
                        handleSubmit={addHandler}
                        failMessage={failMessage}
                        setShowFailMessage={(val) => setShowFailMessage(val)}
                        showFailMessage={showFailMessage}
                        postType={{
                            lowercase: "pattern",
                            capital: "Pattern",
                            capitalLowercase: "Pattern",
                        }}
                        submitButton={
                    <Button onClick={addHandler} className={'preset-modal-button-button'}>
                        Submit
                    </Button>
                        }
                    />
                    <Button
                        onClick={() => dispatch({type: actionTypes.CLOSE_MERGE_MODAL})}
                        className={'preset-modal-cancel-button'}
                    >
                        Cancel
                    </Button>
                </div>
            </div>
            <CustomDragLayer/>
        </DndProvider>
    );
}
